"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Context = require("../Context");
var actions = _interopRequireWildcard(require("../../actions"));
var _toasts = require("../../selectors/toasts");
var _appconfig = require("../../selectors/appconfig");
var _menu = require("../../selectors/menu");
var _KeyValueDB = _interopRequireDefault(require("../../services/KeyValueDB"));
var _styles = require("./styles");
var _getUserGroups = require("../../utils/getUserGroups");
var _useStaticToasts = require("./useStaticToasts");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Toastbar = _react.default.memo(({
  handleNotification
}) => {
  const appconfig = (0, _Context.useSelector)(_appconfig.getAppconfig);
  const toasts = (0, _Context.useSelector)(_toasts.getToasts);
  const {
    toasts: configToasts,
    hideToast: hide,
    clickToast
  } = (0, _useStaticToasts.useStaticToasts)();
  const visibleToasts = (0, _react.useMemo)(() => {
    const groups = (0, _getUserGroups.getUserGroups)();
    const filteredToasts = (configToasts ?? []).filter(({
      userGroup
    }) => !userGroup || groups.includes(userGroup));
    return [...toasts, ...filteredToasts];
  }, [configToasts, toasts]);
  const isMenuExpanded = (0, _Context.useSelector)(_menu.isExpanded);
  const dispatch = (0, _Context.useDispatch)();
  const toast = visibleToasts[0];
  const hideToast = (0, _react.useCallback)((payload, meta) => {
    if (meta.title === 'HIDE') {
      dispatch(actions.clearToast(payload, meta));
      hide(payload);
    } else {
      clickToast(payload, meta);
    }
  }, [clickToast, dispatch, hide]);
  return toast && !!Object.keys(toast).length ? _react.default.createElement(_styles.Toast, {
    actionHandler: handleNotification,
    notification: toast,
    hideHandler: hideToast,
    icon: _KeyValueDB.default.get(toast.id),
    minimized: !appconfig.hiddenMenu && !isMenuExpanded,
    fullWidth: appconfig.hiddenMenu && isMenuExpanded || !appconfig.hiddenMenu && isMenuExpanded
  }) : null;
});
var _default = exports.default = Toastbar;